import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
} from '@angular/core';

@Directive({
  selector: '[customMenuAction]',
  standalone: true,
})
export class CustomMenuActionDirective implements AfterViewInit {
  customColor = input<string>();
  private el = inject(ElementRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      const goaMenuAction = this.el.nativeElement.shadowRoot.querySelector(
        'button'
      ) as HTMLElement;
      if (!goaMenuAction) return;

      const color = this.customColor() || 'var(--goa-color-text-default)';
      goaMenuAction.style.setProperty('color', color, 'important');
    }, 0);
  }
}
